import { Counterparty } from 'types';

import { createCrudApi } from './crud.api';

export const counterpartiesApi = createCrudApi<Counterparty>('/counterparties');
